import React, { useState, useEffect } from "react";
import ImageZoom from "../../../../components/common/ImageZoom";
import { Carousel } from "antd";
import "./index.scss";
const customizedList = [
  {
    name: "上海市公租房签约管理系统",
    imgUrl:
      require("../../../../assets/imagesOld/solution/common/clientCase1.png")
        .default,
    details: "",
    logoUrl: require("../../../../assets/images/logo.png").default,
  },
  {
    name: "临港投控住房管理平台",
    imgUrl:
      require("../../../../assets/imagesOld/solution/common/clientCase2.png")
        .default,
    details: "",
    logoUrl: require("../../../../assets/images/logo.png").default,
  },
  {
    name: "上海地产集团公租房项目",
    imgUrl:
      require("../../../../assets/imagesOld/solution/common/clientCase3.png")
        .default,
    details: "",
    logoUrl: require("../../../../assets/images/logo.png").default,
  },
  {
    name: "临港集团公租房项目",
    imgUrl:
      require("../../../../assets/imagesOld/solution/common/clientCase4.png")
        .default,
    details: "",
    logoUrl: require("../../../../assets/images/logo.png").default,
  },
  {
    name: "上海市黄浦区公租房项目",
    imgUrl:
      require("../../../../assets/imagesOld/solution/common/clientCase5.png")
        .default,
    details: "",
    logoUrl: require("../../../../assets/images/logo.png").default,
  },
  {
    name: "上海市静安区公租房项目",
    imgUrl:
      require("../../../../assets/imagesOld/solution/common/clientCase6.png")
        .default,
    details: "",
  },
  {
    name: "上海市宝山区公租房项目",
    imgUrl:
      require("../../../../assets/imagesOld/solution/common/clientCase7.png")
        .default,
    details: "",
    logoUrl: require("../../../../assets/images/logo.png").default,
  },
  {
    name: "上海市奉贤区公租房项目",
    imgUrl:
      require("../../../../assets/imagesOld/solution/common/clientCase8.png")
        .default,
    details: "",
    logoUrl: require("../../../../assets/images/logo.png").default,
  },
];
function ClientCase() {
  return (
    <div id="clientCase_id" className="clientCase ">
      <div className="edition_solution">
        <div className="edition_solution_title">
          <div>客户案例</div>
          <span>服务各行业标杆企业，创造卓越价值</span>
        </div>
      </div>
      <Carousel
        className="clientCase_con"
        dots={false}
        infinite={true}
        speed={500}
        slidesToShow={3} // 一页显示3个
        slidesToScroll={1} // 每次滚动1个
        autoplay={true}
        arrows={true} // 显示左右箭头
        pauseOnHover={true} // 鼠标悬停暂停
        swipeToSlide={true} // 支持拖动滑动
        draggable={true}
      >
        {customizedList.map((item, index) => {
          return (
            <div key={index} className="li">
              <ImageZoom
                imageUrl={item.imgUrl}
                containerWidth={"380px"} // 容器宽度
                containerHeight={"380px"} // 容器高度
              />
              <div className="li_con">
                <div className="clientCase_img">
                  <img src={item.logoUrl} alt="" />
                </div>
                <div className="clientCase_name">{item.name}</div>
                <div className="clientCase_detail">详情内容</div>
              </div>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}

export default ClientCase;
